import { Typography } from '@ag1/ui';
import styles from './InfoItemV2.module.scss';

type Props = {
  title: string;
  value: string;
};

export const InfoItemV2 = ({ title, value }: Props) => (
  <div className={styles.root}>
    <Typography variant="portalText" size="1" color="grey-1" noPadding>
      {title}
    </Typography>
    <Typography variant="portalText" size="1" weight="700" color="black-new" noPadding>
      {value}
    </Typography>
  </div>
);
